var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('vueper-slides',{ref:"myVueperSlidesMultiple",staticClass:"no-shadow",attrs:{"visible-slides":3,"slide-multiple":"","gap":2,"slide-ratio":1 / 4,"arrows":false,"bullets":false,"dragging-distance":200,"breakpoints":{
            1024: {
                visibleSlides: 2,
                slideMultiple: 2,
                gap: '2'
            },
            800: {
                visibleSlides: 1,
                slideMultiple: 1
            }
        }}},_vm._l((_vm.getTestimonials),function(slide,i){return _c('vueper-slide',{key:i,attrs:{"title":'<b>' +
                    slide.customer_name +
                    '</b></br>' +
                    slide.customer_business,"content":slide.testimonial}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }